export default {
  GET_BOOKINGS: "GET_BOOKINGS",
  ANSWER_AVAILABILITY_CHECK: "ANSWER_AVAILABILITY_CHECK",
  CANCEL_BOOKING: "CANCEL_BOOKING",
  UPLOAD_DELIVERY_RECORD: "UPLOAD_DELIVERY_RECORD",
  UPLOAD_INVOICE: "UPLOAD_INVOICE",
  REMOVE_DOCUMENT: "REMOVE_DOCUMENT",
  GET_BOOKING_COUNT: "GET_BOOKING_COUNT",
};
